import React from 'react'
import styled from 'styled-components'
import { Button } from 'reactstrap'
import { FONTS, COLORS } from '../../../constants'

export default class CalendarRangeMode extends React.Component {
  state = { range: 'month' }
  set(range) {
    this.setState({ range })
    this.props.onChange && this.props.onChange(range)
  }
  render() {
    return (
      <div style={ { display: 'flex', marginLeft: '30%', marginRight: 30, flexDirection: 'row', flex: 1, justifyContent: 'flex-end' } }>
        <RangeButtonLeft onClick={ this.set.bind(this, 'week') } style={ { backgroundColor: this.state && this.state.range === 'week' ? '#ad191f' : 'white', color: this.state && this.state.range === 'week' ? 'white' : '#ad191f' } }>Week</RangeButtonLeft>
        <RangeButtonRight onClick={ this.set.bind(this, 'month') } style={ { backgroundColor: this.state && this.state.range === 'month' ? '#ad191f' : 'white', color: this.state && this.state.range === 'month' ? 'white' : '#ad191f' } }>Month</RangeButtonRight>
      </div>
    )
  }
}

const RangeButtonRight = styled(Button)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  height: 35px;
  border: 1px solid ${COLORS.PRIMARY_RED};
  border-bottom-left-radius: 1%;
  border-top-left-radius: 1%;
`
const RangeButtonLeft = styled(Button)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  height: 35px;
  border: 1px solid ${COLORS.PRIMARY_RED};
  border-bottom-right-radius: 1%;
  border-top-right-radius: 1%;
`



// WEBPACK FOOTER //
// ./src/components/kawari-calendar/components/calendar-range-mode.js